
export class MoveNetPoseWrapper {
    constructor(pose) {
        this.pose = pose;
    }

    get nose() {
        return this.pose.keypoints[0];
    }

    get leftEye() {
        return this.pose.keypoints[1];
    }

    get rightEye() {
        return this.pose.keypoints[2];
    }

    get leftEar() {
        return this.pose.keypoints[3];
    }

    get rightEar() {
        return this.pose.keypoints[4];
    }

    get leftShoulder() {
        return this.pose.keypoints[5];
    }

    get rightShoulder() {
        return this.pose.keypoints[6];
    }

    get leftElbow() {
        return this.pose.keypoints[7];
    }

    get rightElbow() {
        return this.pose.keypoints[8];
    }

    get leftWrist() {

        return this.pose.keypoints[9];
    }

    get rightWrist() {
        return this.pose.keypoints[10];
    }

    get leftHip() {
        return this.pose.keypoints[11];
    }

    get rightHip() {
        return this.pose.keypoints[12];
    }

    get leftKnee() {
        return this.pose.keypoints[13];
    }

    get rightKnee() {
        return this.pose.keypoints[14];
    }

    get leftAnkle() {
        // BlazePose has 33 keypoints (ankle at index 27), MoveNet has 17 (ankle at index 15)
        const isSinglePose = this.pose.keypoints.length > 20;
        return this.pose.keypoints[isSinglePose ? 27 : 15];
    }

    get rightAnkle() {
        // BlazePose has 33 keypoints (ankle at index 28), MoveNet has 17 (ankle at index 16)
        const isSinglePose = this.pose.keypoints.length > 20;
        return this.pose.keypoints[isSinglePose ? 28 : 16];
    }

    get femurLength(){
        let left_knee = this.leftKnee;
        let right_knee = this.rightKnee;
        let left_hip = this.leftHip;
        let right_hip = this.rightHip;
        let left_femur_length = Math.abs(left_knee.y - left_hip.y);
        let right_femur_length = Math.abs(right_knee.y - right_hip.y);
        let femur_length = Math.max(left_femur_length, right_femur_length);
        return femur_length;
    }

    get tibiaLength(){
        let left_knee = this.leftKnee;
        let right_knee = this.rightKnee;
        let left_ankle = this.leftAnkle;
        let right_ankle = this.rightAnkle;
        let left_tibia_length = Math.abs(left_knee.y - left_ankle.y);
        let right_tibia_length = Math.abs(right_knee.y - right_ankle.y);
        let tibia_length = Math.max(left_tibia_length, right_tibia_length);
        return tibia_length;
    }

    is_standing() {
        return this.femurLength > 0.8 * this.tibiaLength;
    }
    
    is_sitting() {
        return this.femurLength < 0.5 * this.tibiaLength;
    }

    get eyeLevel() {
        let left_eye = this.leftEye;
        let right_eye = this.rightEye;
        let eye_level = Math.min(left_eye.y, right_eye.y);
        return eye_level;
    }



}